import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Icon, Text } from 'atoms';
import { Mr1 } from 'wrappers';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
    height: 22px;
    white-space: nowrap;
    width: fit-content;
    background-color: ${displayState?.background};
    color: ${displayState?.color};
    border-radius: 60px;
    font-size: 10px;
    line-height: 22px;
    cursor: ${displayState?.clickable ? 'pointer' : 'unset'};
    user-select: none;
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: wrap(Icon, Mr1),
      name: 'Icon',
      renderIf: ({ icon }) => !!icon,
      displayValue: ({ icon }) => icon
    },
    {
      component: Text,
      name: 'Name',
      renderIf: ({ text }) => !!text,
      displayValue: ({ text }) => text
    },
  ]
})